// extracted by mini-css-extract-plugin
export default {"gpt":"MacBookAir1_gpt__HddSI","headerChild":"MacBookAir1_headerChild__lZGUc","header":"MacBookAir1_header__DWIzG","macbookAir1":"MacBookAir1_macbookAir1__S2FlR"};